'use client';

import Exception from '@/components/Exception';
import { Button } from '@heroui/react';
import { useRouter } from 'next/navigation';

/** 全局错误页面 */
export default function Error({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
  const router = useRouter();
  return (
    <Exception msg={error.message}>
      <div className=" mt-3 flex h-16 items-center justify-center gap-8">
        <Button className="text-white" color="warning" onPress={reset}>
          重试
        </Button>
        <Button color="primary" onPress={() => router.push('/')}>
          返回首页
        </Button>
      </div>
    </Exception>
  );
}
